import { formatCurrency } from './FormatCurrency';

const safeParse = (value) => {
  if (Array.isArray(value)) return value;
  try {
    const parsed = JSON.parse(value || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const getDisplayedPrice = ({
  paymentPlan,
  paymentOptionsBreakdown,
  flexibleTermOptions,
  fairAppPrice,
  quantity = 1,
  termMonths,
  individualBreakdown,
}) => {
  const flexOpts =
    typeof flexibleTermOptions === 'string'
      ? safeParse(flexibleTermOptions)
      : flexibleTermOptions;

  if (Array.isArray(flexOpts) && flexOpts.length > 0) {
    if (paymentPlan === 'full') {
      const fullOpt = flexOpts.find((o) => o.type === 'full');
      return formatCurrency((fullOpt?.totalPrice || fairAppPrice) * quantity);
    }
    const termOpt = flexOpts.find((o) => o.termMonths === (termMonths || 1));
    if (termOpt?.totalPrice) {
      return formatCurrency(termOpt.totalPrice * quantity);
    }
  }

  // Use backend-calculated individual_breakdown when available
  // Backend breakdown already accounts for quantity, so don't multiply again
  if (individualBreakdown && paymentPlan !== 'full') {
    const totalPrice =
      individualBreakdown.downPayment +
      individualBreakdown.installmentAmount *
        individualBreakdown.numberOfInstallments;
    return formatCurrency(totalPrice);
  }

  const options = safeParse(paymentOptionsBreakdown);
  const planOption = options.find((opt) => opt.type === paymentPlan);
  return formatCurrency((planOption?.totalPrice ?? fairAppPrice) * quantity);
};
